import { FC, ReactNode } from 'react';

import { Card, Text, VSpacing } from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import styles from 'components/Dashboard/DashboardBanner/DashboardBanner.module.less';

interface DashboardBannerProps {
    title: string;
    description: string;
    onClose: () => void;
    additionalContent?: ReactNode;
}

export const DashboardBanner: FC<DashboardBannerProps> = ({ title, description, additionalContent, onClose }) => (
    <>
        <VSpacing default={32} />
        <Card style="positive-secondary" stretched padding={20} borderRadius={16}>
            <div className={styles.contentWrapper}>
                <div>
                    <Text typography="title-5-semibold">{title}</Text>
                    <VSpacing default={6} />
                    <Text typography="paragraph-2-regular">{description}</Text>
                </div>
                <CrossOutlinedSize24 initialColor="secondary" onClick={onClose} />
            </div>
            {additionalContent && (
                <>
                    <VSpacing default={20} />
                    {additionalContent}
                </>
            )}
        </Card>
    </>
);
